import { APIClient, AuthConfig, getClient } from '@360mediadirect/api-client'
import React, { createContext, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateRefreshToken, updateUUID } from '../../redux/actions/userActions'
import { RootState } from '../../redux/reducers'
import { getClientApi } from '../../services/client'

interface ClientApiContextType {
  client: APIClient
}

export const ClientApiContext = createContext({
  client: getClient()
})

export const ClientApiContextProvider = (props: { children: React.ReactNode }) => {
  const dispatch = useDispatch()
  const { user } = useSelector((state: RootState) => state)
  const [apiClient, setApiClient] = useState<ClientApiContextType>()

  useEffect(() => {
    if (!user.id) {
      // Create uuid and store it if it is not existed
      dispatch(updateUUID((Math.random() * 100).toString(36).slice(3)))
    }
  }, [dispatch, user.id])

  useEffect(() => {
    setApiClient({ client: getClientApi({ clientId: user.id, product: 'library' }) })
  }, [user.id])

  // eslint-disable-next-line
  const client = () => {
    return apiClient
  }

  useEffect(() => {
    if (user.auth.accessToken) {
      const authConfig = {
        clientId: user.id,
        refreshToken: user.auth.refreshToken,
        accessToken: user.auth.accessToken,
        product: 'library'
      } as AuthConfig
      setApiClient({
        client: getClientApi({
          ...authConfig,
          onTokenRefresh : ((authConfig: any) => {
            const { refreshToken = '' } = authConfig
            dispatch(updateRefreshToken(refreshToken))
          })
        })
      })
    }
    // eslint-disable-next-line
  }, [user.auth.accessToken, user.id])

  return (
    apiClient ? <ClientApiContext.Provider value={apiClient}>
      {props.children}
    </ClientApiContext.Provider> : null
  )
}

export const useClientApiContext = () => useContext(ClientApiContext)
